import { Head, CleanContent } from './ui';
import { ratings } from '../data';

export default function MarketReviews() {
  return (
    <CleanContent><section className="py-5">
        <div className="container">
          <Head eyebrow="Unfiltered Transparency" title="Let the Market Speak"
            text="Discover how genuine customer evaluations pair with real time operational response rates to validate real world performance" />
          <div className="row g-3 mb-3">
            <div className="col-lg-7">
              <div className="border border-line rounded-3 p-4 h-100">
                <div className="market-review-summary mb-3">
                  <div className="market-review-rating">
                    <span className="rating-big">4.6</span>
                    <div>
                      <div className="star-gold">{[...Array(5)].map((_, i) => <i key={i} className="bi bi-star-fill me-1" />)}</div>
                      <span className="p-sm">127 Verified Evaluations</span>
                    </div>
                  </div>
                  <div className="market-review-badges">
                    <span className="badge bg-light text-dark border">Shop</span>
                    <span className="badge tag-green"><i className="bi bi-check-circle me-1" />Verified Transaction Backed</span>
                  </div>
                </div>
                {ratings.map(([n, v, w]) => (
                  <div className="mb-2" key={n}>
                    <div className="d-flex justify-content-between p-sm"><span style={{ fontWeight: 'bold' }}>{n}</span><strong>{v}</strong></div>
                    <div className="bar-track rounded-pill"><div className="bar-fill rounded-pill" style={{ width: `${w}%` }} /></div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-5">
              <div className="border border-line rounded-3 p-4 h-100">
                <div className="h-md mb-1">Being Responsive Builds Confidence</div>
                <p className="p-sm">Prompt communication signals commercial viability, SELECTEZI tracks response health automatically across all incoming business inquiries</p>
                {[["Response Rate", "94%"], ["Median Response Latency", "< 15 mins"], ["Catalog Freshness", "Updated this week"]].map(([k, v]) => (
                  <div className="d-flex justify-content-between border-top border-line py-2 p-sm" key={k}><span>{k}</span><strong>{v}</strong></div>
                ))}
                <div className="bg-soft rounded-2 p-2 p-sm mt-2">Businesses maintaining &gt; 90% responsiveness qualify for priority RFQ distribution</div>
              </div>
            </div>
          </div>
          <div className="bg-soft border border-line rounded-3 p-3 p-sm">
            <strong>Key Distinction:</strong> Customer Rating measures direct buyer satisfaction on transactions while <strong>Star Rank (1 to 10)</strong> measures aggregate operational stature, verification integrity, community reach, and consistency over time
          </div>
        </div>
      </section></CleanContent>
  );
}
